import React from 'react';
import { Radio, Typography } from 'antd';

const { Text } = Typography;

export default function GenderSelector({ label, genders, value, onChange }) {
  return (
    <div>
      <Text strong>{label}</Text>
      <div style={{ marginTop: 12 }}>
        <Radio.Group value={value} onChange={(e) => onChange(e.target.value)}>
          {genders.map((g) => (
            <Radio.Button key={g.key} value={g.key}>{g.label}</Radio.Button>
          ))}
        </Radio.Group>
      </div>
    </div>
  );
}


